import React from 'react'

export default function SmallLoader({className = ''}) {
  return <div className={`small-loader ${className}`}/>
}
